import {Component} from 'react'
import ActiveRender from '../Controls/PeriodPicker/ActiveRender2'

export default class RangePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromOpen: undefined,
      toOpen: undefined,
    };

    this.startTime = props?.startTime ?? new Date(Date.now() - 48*3600 * 1000)
    this.endTime = props?.endTime ?? new Date(Date.now() - 24*3600 *1000)

    this.userRange = false;
    this.handleChangeStart = this.handleChangeStart.bind(this)
    this.onFinish = this.onFinish.bind(this)
    props?.exporter(this.startTime, this.endTime)
  }
  componentDidUpdate(prevProps) {  
    if (this.props?.startTime !== prevProps?.startTime) 
      this.startTime = this.props?.startTime ?? this.startTime
    if (this.props?.endTime !== prevProps?.endTime)
      this.endTime = this.props?.endTime ?? this.endTime
  }
  handleChangeStart(date) {
    this.startTime = date
    this.props?.exporter (date, this.endTime)
    this.setState({fromOpen: undefined});
  }
  onFinish(date) {
    this.userRange = false
    this.endTime = date
    this.props.exporter (this.startTime, date)
    this.setState({toOpen: undefined});
  }
  render() {
    const lines = this.props?.singleLine ? {singleLine: true} : {}
    return (
      <ActiveRender from={this.startTime} to={this.endTime} {...lines}
                    fromOpen={this.state.fromOpen} toOpen={this.state.toOpen}
                    onChange={this.handleChangeStart} onFinish={this.onFinish}/>
    )  
  }
}
